import fonts from './fonts'
import colors, {getColorValue} from './colors'
// import images from './images'
import texts from './texts'
// import styles from './styles'

export const Fonts = fonts
export const Colors = colors
// export const Images = images
export const Texts = texts
// export const Styles = styles
export {getColorValue}
